import { Address } from '../api/customer/types';

/**
 * Форматирует адрес в строку
 * @param address - объект с адресом (Address)
 * @returns отформатированная строка адреса или пустая строка, если адрес не передан
 */
export const formatAddress = (address?: Address): string => {
    if (!address) {
        return '';
    }

    return [address.country, address.city, address.line, address.postcode].filter(Boolean).join(', ');
};
